/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Ajax script that allows to start registration process with phone using forms that are refreshed as modals
	 * STEP 1: phone verification and OTP send
	 */

	function registrationPhoneVerification() {
	    $('#registrationPhoneVerification-form').submit(function (e) {
	        e.preventDefault();
	        var url = $(this).attr('actionurl');
	        var data = {
	            phoneNumber: $('#registrationPhoneVerification-phoneNumber').val(),
	            csrf_token: $('#registrationPhoneVerification-csrf_token').val()
	        };

	        $('#registrationPhoneVerification-phoneNumber').removeClass('is-invalid');
	        $(this).spinner().start();

	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: 'json',
	            data: data,
	            success: function success(data) {
	                if (data.success) {
	                    $(this).spinner().stop();
	                    $('#registrationPhoneVerificationModal').modal('hide');
	                    $('#registrationPhoneOTPValidation-phoneNumber').val(data.phoneNumber);
	                    $('#registrationPhoneOTPValidationModal').modal('show');
	                } else {
	                    $('#registrationPhoneVerification-error').find('.cc-text-message').text(data.error);
	                    $('#registrationPhoneVerification-phoneNumber').addClass('is-invalid');
	                    $(this).spinner().stop();
	                }
	            },
	            error: function error(err) {
	                $('#registrationPhoneOTPValidation-error').find('.cc-text-message').text(data.error);
	                $('#registrationPhoneVerification-phoneNumber').addClass('is-invalid');
	                $(this).spinner().stop();
	            }
	        });
	    });
	}

	/**
	 * Ajax script that allows to start registration process with phone using forms that are refreshed as modals
	 * STEP 2: OTP validation against previously submitted phone number
	 */
	function registrationPhoneOTPValidation() {
	    $('#registrationPhoneOTPValidation-form').submit(function (e) {
	        e.preventDefault();
	        var url = $(this).attr('actionurl');
	        var data = {
	            otpCode: $('#registrationPhoneOTPValidation-otpCode').val(),
	            phoneNumber: $('#registrationPhoneOTPValidation-phoneNumber').val(),
	            csrf_token: $('#registrationPhoneOTPValidation-csrf_token').val()
	        };

	        $('#registrationPhoneOTPValidation-otpCode').removeClass('is-invalid');
	        $(this).spinner().start();

	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: 'json',
	            data: data,
	            success: function success(data) {
	                if (data.success) {
	                    $(this).spinner().stop();
	                    $('#registrationPhoneOTPValidationModal').modal('hide');
	                    $(location).attr('href', data.redirectUrl);
	                } else {
	                    $('#registrationPhoneOTPValidation-error').find('.cc-text-message').text(data.error);
	                    $('#registrationPhoneOTPValidation-otpCode').addClass('is-invalid');
	                    $(this).spinner().stop();
	                }
	            },
	            error: function error(err) {
	                $('#registrationPhoneOTPValidation-error').find('.cc-text-message').text(data.error);
	                $('#registrationPhoneOTPValidation-otpCode').addClass('is-invalid');
	                $(this).spinner().stop();
	            }
	        });
	    });
	}

	function registrationPhoneProcess() {
	    registrationPhoneVerification();
	    registrationPhoneOTPValidation();
	}

	/**
	 * Ajax script for the registration process with phone using forms that are refreshed as modals
	 */
	$(document).ready(registrationPhoneProcess());

/***/ })
/******/ ]);